<template>
  <div class="page-wecom-uauth-entry"></div>
</template>
<script>
import { postOauth } from '../../../../utils/wecom/index';
export default {
  name: 'Entry',
  async created() {
    this.$loading.show();
    await postOauth();
    // this.$loading.hide();
  }
};
</script>
